<template>
    <div id="wrapper h-100">
        <Sidebar :mobile="true" />
        <div class="d-flex flex-column" id="content-wrapper">
            <div id="content h-100">
                <Topbar />
                <MobileMenu :activePage="'Other Receipt'" />
                <div class="container">
                    <div class="row">
                        <div class="col-12">
                            <h4 class="akkurate-green">Other Receipt</h4>
                        </div>
                        <hr />
                        <!--  -->

                        <form @submit.prevent="submitJournalTransfer">
                            <div class="row">
                                <!-- <div class="col-12 col-md-6 mb-2">
                                    <b-form-group class="akkurate-dark small" label="Entry type" v-slot="{ ariaDescribedby }">
                                        <b-form-radio class="akkurate-dark" @change="entryClicked" v-model="form.payment_selected" :aria-describedby="ariaDescribedby
                                            " name="type" value="RECEIPT_ENTRY">Receipt Entry - (Withdrawal From Member Account)</b-form-radio>
                                        <b-form-radio class="akkurate-dark" @change="entryClicked" v-model="form.payment_selected" :aria-describedby="ariaDescribedby
                                            " name="type" value="PAYMENT_ENTRY">Payment Entry - (Deposit To Member Account)</b-form-radio>
                                    </b-form-group>
                                </div> -->

                                <!-- <div class="col-12 col-md-6 mb-2">
                                    <b-form-group label-for="category">
                                        <template #label>
                                            <label class="akkurate-dark small" for="code">Category<star></star>
                                            </label>
                                        </template>
<multiselect class="field-container mt-1" v-model="form.member_category" :options="select_category_options
                                            " label="name" selectLabel="" deselectLabel="" @select="onSelect_category" :preselect-first="true">
</multiselect>
</b-form-group>
</div> -->


                                <div class="col-12">
                                    <label class="akkurate-dark small" for="coa">Select GL <star></star>
                                    </label>
                                    <b-form-group id="coa" label-for="coa">
                                        <multiselect class="mt-1 field-container" v-model="form.coa" :options="coa_subhead_options" label="name" selectLabel="" :custom-label="customLabel" deselectLabel="" :preselect-first="true">
                                        </multiselect>
                                        <errors v-if="form.errors.coa">
                                            {{ form.errors.coa[0] }}
                                        </errors>
                                    </b-form-group>
                                </div>

                                <div class="col-12">
                                    <b-form-group id="amount" label-for="amount">
                                        <template #label>
                                            <label class="akkurate-dark small" for="code">Amount<star></star>
                                            </label>
                                        </template>
                                        <b-input-group class="">
                                            <b-form-input class="field-container fields mt-1" type="text" v-model="form.amount" placeholder="amount " required></b-form-input>
                                        </b-input-group>
                                    </b-form-group>
                                </div>


                                <!-- <div class="col-12 col-md-6">
                                    <label class="akkurate-dark small" for="recorded_date">Date <star></star>
                                    </label>
                                    <b-form-group id="recorded_date" label-for="recorded_date">
                                        <b-input-group class="">
                                            <b-form-input class="field-container fields mt-1" type="date" v-model="form.recorded_date" placeholder="recorded_date"></b-form-input>
                                        </b-input-group>
                                        <errors v-if="
                                            form.errors.recorded_date
                                        ">
                                            {{
                                                form.errors.recorded_date[0]
                                            }}
                                        </errors>
                                    </b-form-group>
                                </div> -->
                                <div class="col-12">
                                    <label class="akkurate-dark small" for="narration">Note <star></star>
                                    </label>
                                    <b-form-group label-for="narration" class="mb-3">
                                        <b-form-textarea id="narration" name="narration" class="mt-2 fields" v-model="form.narration" placeholder="Enter Narration..."></b-form-textarea>
                                    </b-form-group>
                                </div>
                            </div>
                            <!-- <div class="row">
                                    
                                </div> -->
                            <hr class="my-4" />
                            <div class="text-center">
                                <button type="submit" :disabled="isSaving" class="btn akkurate-green-btn text-white btn-size">
                                    <font-awesome-icon class="me-2" :icon="['fas', 'forward']" />
                                    Save
                                </button>
                                <!-- <button type="reset" class="btn akkurate-gray-btn text-white btn-size my-2 ms-3">
                                    <font-awesome-icon class="me-2" :icon="['fas', 'rotate-right']" />
                                    Reset
                                </button> -->
                            </div>
                        </form>
                    </div>
                </div>

                <b-modal id="loading-modal" hide-header hide-footer centered static no-close-on-esc no-close-on-backdrop v-model="isSearching" modal-class="loading-modal">
                    <div class="text-center py-4">
                        <div class="spinner-border akkurate-green" style="width:3rem; height:3rem;" role="status">
                            <span class="sr-only">Loading...</span>
                        </div>
                        <p class="mt-3">Please wait...</p>
                    </div>
                </b-modal>

                <b-modal id="loading-modal" hide-header hide-footer centered static no-close-on-esc no-close-on-backdrop v-model="isSaving" modal-class="loading-modal">
                    <div class="text-center py-4">
                        <div class="spinner-border akkurate-green" style="width:3rem; height:3rem;" role="status">
                            <span class="sr-only">Loading...</span>
                        </div>
                        <p class="mt-3">Please wait Making Payments...</p>
                    </div>
                </b-modal>
            </div>


            <footer></footer>
        </div>

        <!-- AI -->
		 <ChatBot />
		<!-- End AI -->
        <a class="d-inline scroll-to-top" href="#page-top"><i class="fas fa-angle-up"></i></a>
        <!-- <cash-deposit ref="showCashDeposit" :report_data="report_data"></cash-deposit> -->
        <mobile-receipt ref="showMobileReceipt" :report_data="reportData"></mobile-receipt>
        <!-- <mobile-receipt ref="showMobileReceipt" :report_data="report_data"></mobile-receipt> -->
    </div>
</template>
<script>
import Topbar from "@/views/main/components/Topbar.vue";
import Sidebar from "@/views/main/components/Sidebar.vue";
import MobileMenu from "../../../components/MobileMenu.vue";
// import CashDeposit from "../reports/cash/CashDeposit.vue";
import ApiService from "@/core/services/api.service";
import Multiselect from "vue-multiselect";
import MobileReceipt from "./print/MobileReceipt.vue";
import ChatBot from "@/views/components/AI/ChatBot.vue";

export default {
    components: {
        MobileMenu,
        Topbar,
        Sidebar,
        // CashDeposit,
        Multiselect,
        MobileReceipt,
        ChatBot,
    },
    data() {
        return {
            ...this.initialState(),
            institution: {},
            reportData: {},

            // Flags
            isSaving: false,
            isSearching: false,
            isLoading: false,

            teller: {},
            coa_subhead_options: [],
            branch_options: [],
            add_or_edit: "add",
            save: "Save",
            isSaving: false,
            acc_error: "",
            search_btn: "Search",
            search: "",
            select_category_options: [
                { id: "member", name: "Member" },
                { id: "non_member", name: "Non Member" },
            ],
            source: "Source (Debit)",
            destination: "Destination (Credit)",
            accDisabled: false,
            accounts_options: [],
            coa_subhead: "",
            coa_subhead_options: [],
            is_searching: false,
            filter: {
                search: "",
                account_number: "",
            },
        };
    },
    mounted() {
        this.getVoucherDropdown();
        this.getDepositDropdown();
        this.getInsistution();
    },
    methods: {
        accountDetails({ account_number, account_type, account_balance }) {
            return `${account_number} - ${account_type.name}(GHC ${account_balance})`;
        },
        customLabel({ name, code, amount, coabranch }) {
            return `${code} ${name} - (${coabranch.name}) - (GHC ${amount})`;
        },
        async getInsistution() {
            await ApiService.get("/settings/institution")
                .then((response) => {
                    // console.log(response);
                    this.institution = response.data.data;
                })
                .catch((error) => {
                    // console.log(error);
                });
        },
        async getDepositDropdown() {
            this.$Progress.start();
            await ApiService.get("/transactions/deposits/dropdown")
                .then((response) => {
                    this.teller = response.data?.user;
                    console.log(this.teller);
                }).catch((error) => {
                    console.log(error);
                    this.$Progress.fail();
                    this.isLoading = false;
                })
        },
        async getVoucherDropdown() {
            this.$Progress.start();
            await ApiService.get("/journals/dropdown")
                .then((response) => {
                    this.$Progress.finish();
                    console.log(response);
                    this.coa_subhead_options = response.data.coa_subheads;
                })
                .catch((error) => {
                    this.$Progress.fail();
                });

            console.log("Payload", this.form);
        },

        submitJournalTransfer() {
            this.isSaving = true;
            this.$Progress.start();
            this.save = "Saving...";

            // console.log(this.form);
            console.log("Payload", this.form);

            ApiService.post("/journals/transfer/store", this.form)
                .then((response) => {
                    this.isSaving = false;
                    this.$Progress.finish();
                    this.save = "Save";
                    // toast.fire({
                    //     icon: "success",
                    //     title: response.data.message,
                    // });

                    const res = response.data;

                    console.log(res);

                    this.isSaving = false;

                    this.reportData = {
                        trans_date: res?.transaction?.trans_date,
                        institution: this.institution,
                        transaction_mode: res.transaction?.transaction_mode,
                        transaction_type: res.transaction?.transaction_type,
                        amount: res.transaction.trans_amount,
                        cheque_no: "not avaliable",
                        bank_name: "not avaliable",
                        branch_name: this.teller.branch?.name,
                        narration: res.transaction.narration,
                        receipt_no: res.transaction.id,
                        teller: this.teller.first_name + (this.teller.middle_name ? " " + this.teller.middle_name + " " : " ") + this.teller.surname,
                        teller_id: this.teller.id,
                        denomination: res.transaction?.denominations ?? [],
                        external_reference: res.transaction?.external_reference,
                        user_glCode: res.transaction?.current_user_coa?.code,
                        user_glName: res.transaction?.current_user_coa?.name,
                        selectedGlCode: res.transaction?.transfered_coa_subhead?.code,
                        selectedGlName: res.transaction?.transfered_coa_subhead?.name,
                        selectedGlNote: this.form.narration
                    };
                    this.form = this.initialState().form;
                    swal.fire({
                        title: "Success",
                        text: response.data.message,
                        // text: "Saved successfully",
                        confirmButtonColor: "#018673",
                        icon: "success",
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                        showCancelButton: true, // Show the "Cancel" button
                        confirmButtonText: "OK", // Customize the text for the "OK" button
                        cancelButtonText: "Print", // Text for the custom button
                        buttonsStyling: false, // Disable SweetAlert2 styling for buttons
                        customClass: {
                            confirmButton:
                                "btn btn-size akkurate-green-btn modal-btn-width text-white me-2", // Custom class for the "OK" button
                            cancelButton:
                                "btn btn-size akkurate-ash modal-btn-width text-white", // Custom class for the custom button
                        },
                    }).then((result) => {
                        if (result.isConfirmed) {
                            this.$bvModal.hide("loan_repayment");
                        } else if (result.isDismissed) {
                            this.$refs.showMobileReceipt.showModal();
                        }

                        // this.$refs.showMobileReceipt.showModal();
                    })
                        .catch((error) => {
                            this.isSaving = false;
                            this.$Progress.fail();
                            this.save = "Save";
                            // console.log(error);
                            if (error.response.data) {
                                this.form.errors = error.response.data.message;
                            }

                            //error message
                            if (error.response.data.message) {
                                this.form.message = error.response.data.message;
                            }
                            console.log(error.response.data)

                        });
                })
        },

        initialState() {
            return {
                form: {
                    amount: "",
                    recorded_date: new Date().toLocaleDateString("en-CA"),
                    narration: "",
                    coa: "",
                    product: "",
                    payment_selected: "RECEIPT_ENTRY",
                    errors: [],
                    member: "",
                    member_category: { id: "non_member", name: "Non Member" }
                },
            };
        },
        onSelect_category(event) {
            if (event.id === "non_member") {
                this.accDisabled = true;
                this.form.member = "";
                this.form.product = "";
            } else {
                this.accDisabled = false;
            }
        },
    },
};
</script>

<style scoped>
.input-group>.custom-group {
    position: relative;
    flex: 1 1 auto;
    width: 1%;
    min-width: 0;
}

.icon_color {
    color: #c1c2c4;
}

.card-info {
    display: flex;
    flex-grow: 1;
    flex-direction: column;
}

.card-info h5,
.card-info p {
    padding: 0;
    margin: 0;
}

.card-info h5 {
    font-size: 1.1rem !important;
    font-weight: 700;
    text-wrap: wrap;
}

.card-info p {
    color: #555555;
    padding: 0;
    margin: 0;
}
</style>
